module.exports = __webpack_public_path__ + "88a3b46fc384b9dc3bd06b1183959467.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-CondBold.eot
 ** module id = 356
 ** module chunks = 9
 **/